import React, { useState, useEffect } from "react";
// import { Route, Routes, useNavigate } from 'react-router-dom';

import Rpt1 from "./ReportTabs/Report1.js";
// import Rpt2 from "./ReportTabs/Report2.js";
import Rpt3 from "./ReportTabs/Report3.js";
// import FirstPage from "./ReportTabs/ReportWelcomePage.js";
import PA from "./ReportTabs/PersonalArea.js";
import TestPage from "./ReportTabs/TestPage.js";

import "./ReportTabs/ReportCss/ReportsPage.css";
import SimpleDialog from '../Components/Global/SimpleDialog'

const ReportsPage = ({ navigation }) => {

  const [activeTab, setActiveTab] = useState("rpt1");//about

  const [currCntrctNum, SetCurrCntrct] = useState('');
  const [currentKey, SetCurrentKey] = useState(0);

  const [currCntrctComp, SetCurrComp] = useState('');
  const [currProjData, SetCurrProjData] = useState([]);

  const [open, setOpen] = useState(false);

  const [rpt1, SetDataRpt1] = useState([]);
  const [rpt3, SetDataRpt3] = useState([]);

  // const [rptParms1, SetrptParms1] = useState();
  // const [colParams1, SetcolParams1] = useState();
  // const [rptParms3, SetrptParms3] = useState(); 
  // const [colParams3, SetcolParams3] = useState();


  // var lItem = "";

  // update the state to tab1
  function handleTab(val) {
    setActiveTab(val);
  };

  useEffect(() => {

    if(localStorage.length == 0)
    {
      window.history.replaceState(null, '', '/');
      //navigate('./', { replace: true });
      return;
    }

debugger;
    var projData = (JSON.parse(localStorage.getItem("proj"))).contract[0];
    var selectedNum = projData.cntNum;
    var selectedComp = projData.comp;
    SetCurrProjData(projData);
    SetCurrCntrct(selectedNum);
    SetCurrComp(selectedComp);
    SetCurrentKey(0)
   
  }, []);

  function onSelect(e) {

    if(localStorage.length == 0)
    {
      window.history.replaceState(null, '', '/');
      return;
    }

    debugger
    let selectedIndex = e.target.options.selectedIndex
    let selectedNum = (JSON.parse(localStorage.getItem("proj"))).contract[selectedIndex].cntNum;
    let selectedComp = (JSON.parse(localStorage.getItem("proj"))).contract[selectedIndex].comp;
    SetCurrProjData((JSON.parse(localStorage.getItem("proj"))).contract[selectedIndex]);
    SetCurrentKey(selectedIndex)
    SetCurrCntrct(selectedNum);
    SetCurrComp(selectedComp);

    SetDataRpt1([]);
    SetDataRpt3([]);
   
  }

  function ShowContacts()
  {   
    handleOpen();
    // console.log(currProjData);
    // alert("תיאום אספקות: " +currProjData.cntctData.slp1 +" ☎ "+ currProjData.cntctData.slp1Phone
    // +" \nזימון דיירים: "+currProjData.cntctData.slp2+" ☏ "+currProjData.cntctData.slp2Phone);
  }
  
  function OnClickExit()
  {   
    localStorage.clear();
  }

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

   const handleData1 = (data) => {
    SetDataRpt1(data);
  };  
  
  const handleData3 = (data) => {
    SetDataRpt3(data);
  };

  // const OpenMailTo = (e) => {
  //     //  debugger;
  //      window.location.href ='mailto:'+ e.target.id + '?subject=פניה מאתר קבלנים, חוזה ' + currCntrctComp +'-'+currCntrctNum;

  // }


  return ( currCntrctNum != ""?
    <div  >

      <div className="header-container">
        <div className="logo">
          <div className="imgEffect"><img className="imgBum" src={currCntrctComp == "CM" ? "/images/CmBum.png" : "/images/DrBum.png"}></img></div>
          <img style={{ position: 'absolute', top: 41, width: 120, height: 65, left: 16, cursor: 'pointer' }} alt='tubol img'
            src={currCntrctComp == "CM" ? "/images/‏‏logoCmWithoutBum.png" : "/images/‏‏logoDrWithoutBum.png"}
            onClick={ ()=> window.open(currCntrctComp == "CM" ? "https://www.tuboul-ceramics.co.il/" : "https://tuboul-doors.co.il/")} ></img>
        </div>

      </div>
      <div >  {/* className="TubTabs" */}
        <ul className="navTub">
          <div className="navTubLi">
            {/* <li className={`li-header1 ${activeTab === "about" && "active"}`} onClick={() => handleTab("about")}>ראשי</li> */}
            <li >
              <div class="container" onClick="myFunction(this)">
              <div class="bar1"></div>
              <div class="bar2"></div>
              <div class="bar3"></div>
            </div></li>
            <li className={`li-header2 ${activeTab === "rpt1" && "active"}`} onClick={() => handleTab("rpt1")}>דוח מרוכז</li>
            <li className={`li-header3 ${activeTab === "rpt3" && "active"}`} onClick={() => handleTab("rpt3")}>דוח מפורט</li>
            <li className={`li-header4 ${activeTab === "contctUs" && "active"}`} onClick={() => handleTab("contctUs")}>צור קשר</li>
            {/* <li className={`li-header4 ${activeTab === "TestPage" && "active"}`} onClick={() => handleTab("TestPage")}>test</li> */}
          </div>

          {activeTab !== "contctUs" && <div className="hdrRptR js-center">

            <p className="bold title-projects" style={{ color: "white" }}>פרויקט:  </p>
            <div >
              <select className="select-projects" onSelect={e => onSelect(e)} onChange={onSelect} onFocus="this.selectedIndex = -1;">
                {
                  (JSON.parse(localStorage.getItem("proj")).contract.map((item, index) => {
                    return <option key={index} value={item.key}>{item.cntrct}</option>;
                  }
                  ))}
              </select>
            </div>
            <p className="projDscrpt"> קוד קבלן: {currProjData.card}</p>
            <p className="projDscrpt"> מספר בניינים: {currProjData.bldCount}</p> 
            <p className="projDscrpt">מספר יח"ד: {currProjData.appCount}</p> 
            <p className="projCU" title="אנשי קשר" onClick={ShowContacts}><a>☎</a></p>
            <p title="יציאה" onClick={OnClickExit}><a className="projExit" href="./"> יציאה</a></p>
            {/* <p className="bold title-projects" ><span>קוד חוזה: </span>{currCntrctNum}</p>
            <p className="bold"><span> סוג:</span> {currCntrctComp == "CM" ? "קרמיקה" : "דלתות"}</p> */}

          </div>}
        </ul>
        {currProjData.cntctData ?  
        <div className="details-contract"  style={{ direction: "rtl" }}>
           <div className="detailsCntrctName" >
          זימון דיירים: {currProjData.cntctData.slp2} ☏ {currProjData.cntctData.slp2Phone}
           ||  
          תיאום אספקות: {currProjData.cntctData.slp1} ☎ {currProjData.cntctData.slp1Phone} </div>           
         <div className="detailsCntrctMail" id={currProjData.cntctData.slp1Mail} 
        //  onClick={(e) => OpenMailTo(e)} 
         >
          <a href={'mailto:'+ currProjData.cntctData.slp1Mail + '?subject=פניה מאתר קבלנים, חוזה ' + currCntrctComp +'-'+currCntrctNum}> מייל: {currProjData.cntctData.slp1Mail} </a></div> 
         </div>: ''}
      
    

        {/* <div className="details-contract" style={{direction:"rtl"}}>
          <div className="contact-span">  תיאום אספקות:</div> 
         <div className="contact-span"> אביגיל כהן </div>
          <div className="contact-span-two">  08-8888888</div>     
       
          <div className="contact-span">  זימון דיירים:</div> 
          <div className="contact-span"> לי ורדיגר</div>
          <div className="contact-span-two">  08-8888888</div>
         
      </div> */}
      

        <div className="outlet">
          {
            // activeTab === "about" ? <FirstPage cntrct={currCntrctNum} cntComp={currCntrctComp}
            //   currentKey={currentKey} /> :
            // activeTab === "rpt2" ? <Rpt2 cntrct={currCntrctNum} cntComp={currCntrctComp}
            //   currentKey={currentKey} /> :
              activeTab === "rpt1" ? <Rpt1 cntrct={currCntrctNum} cntComp={currCntrctComp}
                  currentKey={currentKey} reportData={rpt1} setData={handleData1} handleTab={handleTab} /> :

                activeTab === "rpt3" ? <Rpt3 cntrct={currCntrctNum} cntComp={currCntrctComp}
                  currentKey={currentKey} reportData={rpt3} setData={handleData3} handleTab={handleTab}/>:

                activeTab === "TestPage" ? <TestPage cntrct={currCntrctNum} cntComp={currCntrctComp}
                  currentKey={currentKey} />

                  : activeTab === "contctUs" && <PA  cntrct={currCntrctNum} cntComp={currCntrctComp} currentKey={currentKey} />
          }
        </div>
      </div>

<div>      <SimpleDialog open={open} handleClose={handleClose}  dataC={currProjData.cntctData}/></div>
 {/* dataC={ currProjData != null && currProjData.cntctData.slp1} */}
      {/* {activeTab !== "contctUs"&&<div className="footer-container"></div>} */}

      {/* ColsParams={colParams1} ColsParamsSet={SetcolParams1} 
                  ReportParams={rptParms1} ReportParamsSet={SetrptParms1} */}

    </div>
                :'');
}

export default ReportsPage;